// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".history-details__tabs-card[data-v-49ce810f]{padding:0!important}@media(max-width:1279px){.history-details__tabs-card[data-v-49ce810f]{max-width:768px}}", ""]);
// Exports
module.exports = exports;
